import { z } from 'zod';
import superjson from 'superjson';

export const schema = z.object({
  tier: z.enum(['basic', 'pro', 'enterprise']),
  billing: z.enum(['monthly', 'annual']).default('monthly'),
});

export type InputType = z.infer<typeof schema>;
export type OutputType = { url: string };

export const postCheckout = async (body: InputType, init?: RequestInit): Promise<OutputType> => {
  const result = await fetch('/_api/subscription/checkout', {
    method: 'POST',
    credentials: 'include',
    ...init,
    headers: { 'Content-Type': 'application/json', ...(init?.headers ?? {}) },
    body: superjson.stringify(body),
  });
  if (!result.ok) {
    const err = await result.text();
    try {
      const parsed = superjson.parse<{ error: string }>(err);
      throw new Error(parsed.error);
    } catch {
      throw new Error(err || 'Checkout failed');
    }
  }
  return superjson.parse<OutputType>(await result.text());
};
